"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Item.css");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : ItemLink.js
* Description : Ce fichier contient la définition du composant ItemLink 
*               Ce composant est un cadre clickable pour afficher un élément d'une liste 
*               et accéder au détail de cet élément
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* ItemLink : ce composant est un cadre pour afficher un élément d'une liste
*            un click sur cet élément renvoi vers le détail de l'élément sur une autre page
*
* Type : composant 
*
* Parametres : 
*  - children -- contenu de l'élément à afficher
*  - id -- id de l'élément 
*  - path -- Url à combiner avec l'id de l'élément pour renvoyer la page correspondante
*/function ItemLink(_ref) {
  var children = _ref.children,
    id = _ref.id,
    path = _ref.path,
    onClick = _ref.onClick;
  var pathRoute = path.concat(id);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "item-border",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
      to: pathRoute,
      className: "item-text",
      onClick: onClick,
      children: children
    })
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
ItemLink.propTypes = {
  id: _propTypes["default"].number
};
var _default = exports["default"] = ItemLink;